import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EmbryoService } from 'src/app/Services/Embryo.service';

@Component({
  selector: 'embryo-LanguageDropDown',
  templateUrl: './LanguageDropDown.component.html',
  styleUrls: ['./LanguageDropDown.component.scss']
})
export class LanguageDropDownComponent implements OnInit {

   currentLang = 'tr';

   langArray = [
      {
         name:"English",
         value:"en"
      },
       {
         name: "Türkçe",
         value:"tr"
      },
       {
         name: "French",
         value:"fr"
      }
   ]

   constructor(public translate: TranslateService, public embryoService:EmbryoService) { }

   ngOnInit() {
   }

}
